import React from 'react'
import PageBlocks from '../cms-page-blocks/list'

// Blocks are split between the main column and the right sidebar by the
// `placement` field on each block, not by position.
const EventsPageBlockEditor = (props) => {
  return (
    <PageBlocks
      title='Events Page Blocks'
      target='cms_fixed_page_blocks'
      cmsPageProp='page'
      cmsPageId='events_page'
      allowedBlockTypes={[
        'MemberResources',
        'CoreCurriculumProgress',
        'WhatsNew',
        'EventsPromoBanner',
        'GenericHtml'
      ]}
      route={props.route}
    />
  )
}

export default EventsPageBlockEditor
